module.exports = __webpack_public_path__ + "static/media/InstrumentSans-SemiBold.ce61a28a.woff2";